import get from "lodash/get"
import { languageIsRTL } from "../../configure/i18n"
import { currentCompany, isCurrentCompanyAppical } from "../../constants"

const styles = (theme) => {
    let appicalLogo = {
        textAlign: "center",
        marginBottom: "32px",
    }
    let welcomeTitle = {
        marginBottom: "32px",
    }

    let textBelow = {
        minHeight: "16px",
        marginTop: get(theme, "appicalTheme.spacing.small"),
        textAlign: "center",
    }

    let simpleLink = {
        color: "inherit",
        textDecoration: "none",
    }

    let buttonContainer = {
        textAlign: "center",
        marginTop: get(theme, "appicalTheme.spacing.medium"),
    }

    let fieldWithBackButtonContainer = {
        position: "relative",
    }

    let loginFormContainer = {
        width: "100%",
        margin: "0 auto",
        padding: "24px",

        [theme.breakpoints.up("sm")]: {
            width: "424px",
        },
    }

    let loginButton = {
        "&:focus-visible": {
            borderColor: "rgba(0,0,0,1)",
            borderWidth: "2px",
            borderStyle: "solid"
        }
    }

    let hidePasswordField = {}
    let showPasswordField = {}

    if (isCurrentCompanyAppical) {
        appicalLogo = {
            ...appicalLogo,
            marginBottom: get(theme, "appicalTheme.spacing.smallest"),
            lineHeight: "0",
        }
        welcomeTitle = {
            ...welcomeTitle,
            marginBottom: get(theme, "appicalTheme.spacing.gap"),
            fontWeight: "bold",
            fontSize: "26px",
            lineHeight: "26px",
        }

        simpleLink = {
            ...simpleLink,
            color: get(theme, "appicalTheme.loginButton"),
            display: "inline-block",
            fontSize: "16px",
            lineHeight: "normal",
        }

        buttonContainer = {
            ...buttonContainer,
            marginTop: get(theme, "appicalTheme.spacing.small"),
        }
        fieldWithBackButtonContainer = {
            ...fieldWithBackButtonContainer,
            paddingTop: get(theme, "appicalTheme.spacing.small"),
        }
    }
    if (currentCompany === "dt") {
        welcomeTitle = {
            ...welcomeTitle,
            color: get(theme, "appicalTheme.loginBgText"),
        }
    }
    if (currentCompany === "heineken") {
        welcomeTitle = {
            ...welcomeTitle,
            color: get(theme, "appicalTheme.loginBgText"),
            fontWeight: "bold",
        }
    }
    if (currentCompany === "arkin") {
        welcomeTitle = {
            ...welcomeTitle,
            color: get(theme, "appicalTheme.loginBgText"),
            fontWeight: "bold",
        }
    }
    if (currentCompany === "allianzgi") {
        welcomeTitle = {
            ...welcomeTitle,
            fontSize: "1rem",
        }
        simpleLink = {
            ...simpleLink,
            color: `${get(theme, "appicalTheme.contrast")} !important`,
            display: "inline-block",
            lineHeight: "normal",
        }
    }
    if (currentCompany === "ep") {
        welcomeTitle = {
            ...welcomeTitle,
            color: get(theme, "appicalTheme.loginBgText"),
        }
        loginFormContainer = {
            ...loginFormContainer,
            [theme.breakpoints.up("sm")]: {
                width: "480px",
            },
        }
        appicalLogo = {
            ...appicalLogo,
            marginBottom: "64px",
        }
    }
    if (currentCompany === "nn-sk") {
        welcomeTitle = {
            ...welcomeTitle,
            fontWeight: "bolder",
            color: get(theme, "appicalTheme.white"),
        }
    }
    if (currentCompany === "capgemini") {
        loginButton = {
            fontSize: "1rem",
        }
        hidePasswordField = {
            display: "none",
        }
        showPasswordField = {
            display: "block",
        }
    }
    if (currentCompany === "worldline") {
        welcomeTitle = {
            ...welcomeTitle,
            fontWeight: "bolder",
            color: get(theme, "appicalTheme.white"),
        }
    }
    if (currentCompany === "kpmg") {
        welcomeTitle = {
            marginTop: "-20px",
            color: get(theme, "appicalTheme.white"),
            marginBottom: "5px",
            fontWeight: "bold",
            letterSpacing: "1px",
            fontSize: "21px",
        }
        appicalLogo = {
            textAlign: "center",
            marginBottom: "0",
        }
        loginFormContainer = {
            ...loginFormContainer,
            [theme.breakpoints.up("sm")]: {
                width: "375px",
            },
            color: get(theme, "appicalTheme.white"),

        }
    }
    if (currentCompany === "motion") {
        welcomeTitle = {
            ...welcomeTitle,
            color: get(theme, "appicalTheme.white"),
        }
    }
    if (currentCompany === "legerdesheils") {
        welcomeTitle = {
            ...welcomeTitle,
            color: "#F4F2EF",
        }
    }
    if (currentCompany === "asml") {
        welcomeTitle = {
            ...welcomeTitle,
            color: "#273478",
        }
    }
    if(currentCompany === "landal"){
        welcomeTitle = {
            ...welcomeTitle,
            color: "#FFFFFF",
        }
    }
    if (currentCompany === "ergomed") {
        welcomeTitle = {
            ...welcomeTitle,
            color: get(theme, "appicalTheme.loginBgText"),
        }
    }
    return {
        form: {
            ...loginFormContainer,
        },

        appicalLogo,

        welcomeTitle,

        flex: {
            flex: "1",
            flexGrow: 1,
            flexShrink: 0,
            flexBasis: "auto",
            paddingTop: get(theme, "appicalTheme.spacing.gap"),
        },

        textBelow,

        simpleLink,

        buttonContainer,

        fieldWithBackButtonContainer,

        loginButton,
        hidePasswordField,
        showPasswordField,

        backButton: {
            position: "absolute",
            right: "100%",
            top: "-4px",
            transform: languageIsRTL() ? "rotate(180deg)" : "",
        },

        checkbox: {
            color: `${get(theme, "appicalTheme.loginBgText")} !important`,
            marginTop: get(theme, "appicalTheme.spacing.smallest"),
        },

        cookieConsentContainer: {
            bottom: "70px",
            right: get(theme, "appicalTheme.spacing.large"),
            backgroundColor: get(theme, "appicalTheme.loginButton"),
            position: "fixed",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            [theme.breakpoints.down("sm")]: {
                left: get(theme, "appicalTheme.spacing.large"),
            },
            [`${theme.breakpoints.down("sm")} and (orientation: landscape)`]: {
                position: "static",
                margin: `0 ${get(theme, "appicalTheme.spacing.small")}`,
                marginBottom: `${get(theme, "appicalTheme.spacing.small")}`,
            },
            [theme.breakpoints.down("xs")]: {
                position: "static",
                margin: `0 ${get(theme, "appicalTheme.spacing.small")}`,
                marginBottom: `${get(theme, "appicalTheme.spacing.small")}`,
                display: "block",
            },
        },
        cookieContent: {
            margin: `${get(theme, "appicalTheme.spacing.gap")} ${get(theme, "appicalTheme.spacing.smallest")}`,
        },
        cookieConsentContainerText: {
            color: get(theme, "appicalTheme.loginButtonText"),
        },
        cookiebutton: {
            extend: "cookieContent",
            backgroundColor: get(theme, "appicalTheme.loginButtonText"),
            color: get(theme, "appicalTheme.loginButton"),
            border: "none",
            padding: "4px 12px",
        },
        input: {
            backgroundColor: get(theme, "appicalTheme.inputBackgroundColor"),
            borderColor: get(theme, "appicalTheme.inputBorderColor"),
            "&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus": {
                borderColor: get(theme, "appicalTheme.inputBorderColor"),
                WebkitTextFillColor: "inherit",
                WebkitBoxShadow: "none",
                transition: "background-color 5000s ease-in-out 0s",
            },
            borderRadius: "4px",
        },
        createAccountButtonWrapper: {
            display: "flex",
            justifyContent: "center",
            fontSize: "16px",
            marginBottom: get(theme, "appicalTheme.spacing.small"),
            [theme.breakpoints.down("sm")]: {
                display: "block",
                textAlign: "center",
            },
        },
        createAccountText: {
            fontSize: "16px",
            marginRight: get(theme, "appicalTheme.spacing.gap"),
        },
        createAccountLink: {
            color: get(theme, "appicalTheme.loginButton"),
            textDecoration: "none",
            fontSize: "16px",
        },
        createAccountKmpg: {
            color: get(theme, "appicalTheme.white"),
            marginLeft: "5px",
        },
        dontHaveAccountKmpg: {
            color: get(theme, "appicalTheme.white"),
        },
        welcomeTitle2: {
            color: get(theme, "appicalTheme.white"),
            marginBottom: "5px",
            fontWeight: "bold",
            letterSpacing: "1px",
            fontSize: "21px",
        },
    }
}

export default styles
